























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  EventsApi,
  PartnersApi,
  UnitsApi,
  MarketsApi,
  EventNew,
  AutoschedulerApi,
  Unit,
  Event,
  EventType,
  UnitTogglePartners,
  PartnerWithKeys,
} from '@compassdigital/foodworks.ts.sdk';
import { orderBy } from 'lodash';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import ToastModule from '@/store/modules/toast';
import SchedulerList from '@/components/SchedulerList/index.vue';
import PartnerList from '@/components/Form/Scheduler/PartnerList/index.vue';
import UnitList from '@/components/Form/Scheduler/UnitList/index.vue';
import Searchfield from '@/components/Form/Searchfield/index.vue';
import AcceptAvailability from '@/components/Modal/AcceptAvailability/index.vue';
import DeclineAvailability from '@/components/Modal/DeclineAvailability/index.vue';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import SystemModule from '@/store/modules/system';
import MarketUtil from '@/util/MarketUtil';
import UnitsUtil from '@/util/UnitUtil';
import ScheduleUtil from '@/util/ScheduleUtil';
import Format from '@/util/Format';
import FlagUtil from '@/util/FlagUtil';
import {
  addMonths, startOfMonth, endOfMonth, formatISO,
} from 'date-fns';
import moment from 'moment';

@Component({
  components: {
    TextButton,
    SchedulerList,
    PartnerList,
    UnitList,
    Searchfield,
    AcceptAvailability,
    DeclineAvailability,
  },
})

export default class Scheduler extends Vue {
  public type: string = 'month';

  public absolute: boolean = true;

  public availabilityEventDialog: string = '';

  public availabilityEventLoading: boolean = false;

  public availabilityEvent: any = {};

  public allowoverflow: boolean = true;

  public menu: boolean = false;

  public isControl: boolean = false;

  public focus: string = '';

  public start: any = Format.getCurrentDate();

  public end: any = Format.getCurrentDate();

  public value: any = {};

  private marketItems: any[] = [];

  public marketValue: any = '';

  public loading: boolean = false;

  public errors: string = '';

  public unitUser: any = {};

  public partnersInMarkedID: any = {};

  public partnerUser: any = {};

  public unitUserMapped: any = {};

  public partnerValue: any = {};

  public eventHeight: number = 50;

  public saving: boolean = false;

  private search: any = '';

  public eventMeta: any[] = [];

  public dateOfEvent: any = '';

  public selectedUnitID: string = '';

  public selectedDate: string = '';

  public error: string = '';

  public eventsAll: any = {};

  public eventFetched: any = {};

  public fetchedUnAvailableEvents: any = {};

  public fetchedCancelEvents: any = {};

  public fetchedNoResponseEvents: any = {};

  public unitsPopupPattern: any = {};

  public isOpen: boolean = false;

  public toggleEventID: string = '';

  public partnerInMartkets: any = {};

  public partnerPublishDate: string = '';

  public partnerSelectID: string = '';

  public selectedItemUnit: string = '';

  public eventSelectionLoader: boolean = false;

  public indexClicked: any = '';

  public notesDecline: string = '';

  public eventData: any = {};

  public eventCancelCheck: any = '';

  public greyOutUsers: any = '';

  public assignedPartners: any = '';

  public assignedUnitUsers: any = '';

  public cancelEvent: any = '';

  public spanValue: any = Format.getCurrentDate();

  public eventSelectedDate: any = '';

  public unitNameSelected: string = '';

  public publishPartnerLoader: boolean = false;

  public startDatePublish: any = '';

  public endDatePublish: any = '';

  public unitListIcon: boolean = false;

  public noResponseEvent: any = '';

  public currentDate: any = Format.getCurrentDate();

  public publishedItems: any = [
    {
      text: 'Restaurants',
      value: 'partners',
    },
    {
      text: 'Units',
      value: 'units',
    },
  ];

  public marketGenerationStatus: Set<string> = new Set<string>();

  public scheduleJobLoading: Set<string> = new Set<string>();

  public loadingIntervals: Map<string, number> = new Map<string, number>();

  public test: number = 0

  public restaurantExcluded: Unit[] = [];

  public cuisinesExcluded: Unit[] = [];

  public eventsInMarketIDs : Event[] = [];

  public eventExclude: any[] = [];

  public eventExcludeCuisine: any[] = [];

  public toggleLoading: boolean = false;

  public unitListLoading: boolean = false;

  public disableList: boolean = false;

  public disableMarkets: boolean = false;

  public disablePartners: boolean = false;

  public disableUnits: boolean = false;

  public loadingMarkets: boolean = false;

  public get scheduleLoading() {
    let { date } = this.start;
    if (!date) {
      date = this.spanValue || this.$route.query.date;
    }
    date = (date as string).substr(0, 7);
    return this.scheduleJobLoading.has(date);
  }

  public mounted() {
    if (this.$route.params) {
      const { marketId } = this.$route.params;
      this.marketValue = marketId;
    }
    this.getMarkets();
    this.getUnits();
    this.getPartnersInMarket();
    // this.getAllEvents();
    this.getMarketGenerationStatus();
  }

  public get title() {
    const { start, end } = this;
    if (start === null && end === null) {
      return '';
    }

    const calDate = start.date;
    this.partnerPublishDate = calDate;

    switch (this.type) {
      case 'month':
        return Format.getCalendarTitle(this.spanValue);

      default:
        return '';
    }
  }

  public get navigationDisabale() {
    const { marketId } = this.$route.params;
    if (marketId) {
      if (marketId !== this.marketValue) {
        this.marketValue = marketId;
        this.getMarkets();
        this.getUnits();
        this.getPartnersInMarket();
        // this.getAllEvents();
        this.getMarketGenerationStatus();
      }
    }
    const formattedDate = new Date();
    const updatedMonth = formattedDate.setMonth(formattedDate.getMonth() + 6);
    const calendarDate = Format.getSchedulerDate(updatedMonth);
    const { start, end } = this;
    if (start === null) {
      return '';
    }
    const { date } = this.start;
    const changedDate = Format.getSchedulerDate(date);
    if (calendarDate === changedDate) {
      return true;
    }
    if (date === undefined) {
      const onReloadDate = Format.getSchedulerDate(this.start);
      if (calendarDate === onReloadDate) {
        return true;
      }
    }
    return false;
  }

  public get previousMonth() {
    const date = new Date();
    const calYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1;
    const { start } = this;
    if (!start) {
      return false;
    }
    const { month } = this.start;
    const { year } = this.start;
    if (calYear > year) {
      return true;
    }
    if (month === currentMonth) {
      return false;
    } if (month >= currentMonth && calYear <= year) {
      return false;
    } if (month < currentMonth && calYear < year) {
      return false;
    }
    return true;
  }

  public get nonWorkingEvents() {
    const events = this.eventMeta;
    const date = moment().format('YYYY-MM');
    const nonWorkingEvents = !events
      || events.filter((el: Event) => moment(el.date).format('YYYY-MM') === date && el.type === EventType.NonWorking);
    return nonWorkingEvents.length > 0;
  }

  public get pastMonth() {
    const date = new Date();
    const calendarPrevious = date.getMonth();
    const calYear = date.getFullYear();
    const currentMonth = calendarPrevious + 1;
    const { start } = this;
    if (!start) {
      return false;
    }
    const { month } = this.start;
    const { year } = this.start;
    if (calYear < year) {
      return false;
    }
    if (month === currentMonth || (calendarPrevious >= month && calYear >= year)) {
      return true;
    }
    return false;
  }

  public get disablePublishPartners() {
    const { start } = this;
    if (!start) {
      return null;
    }
    const value = ScheduleUtil.disablePublishPartner(start);
    return value;
  }

  public async getMarketGenerationStatus() {
    const marketId = this.marketValue;

    // remove all previous set intervals
    [...this.loadingIntervals.values()].forEach(e => clearInterval(e));
    this.loadingIntervals.clear();

    try {
      const marketApi = new MarketsApi(AppModule.apiConfig);
      const { data: schedules } = await marketApi.getScheduleGenerationInfo(marketId);
      const scheduleApi = new AutoschedulerApi(AppModule.apiConfig);
      schedules.forEach((s) => {
        if (s.completed === false) {
          this.scheduleJobLoading.add((s.date as string).substr(0, 7));
          const setIntervalNum = setInterval(async () => {
            const { data: newS } = await scheduleApi.getSchedulerJobById(s.id as string);
            if (newS.completed) {
              clearInterval(this.loadingIntervals.get(s.id as string));
              this.loadingIntervals.delete(s.id as string);
              this.scheduleJobLoading.delete(newS.date.substring(0, 7));
              this.test += 1;
              this.marketGenerationStatus.add(newS.date.substr(0, 7));
              if ((newS as any).output) {
                try {
                  const output = JSON.parse((newS as any).output);
                  ToastModule.setToast({
                    message: `Created ${output.numberOfevents} event(s)`,
                    timeout: 5000,
                  });
                } catch {
                  //
                }
              } else if ((newS as any).errors) {
                try {
                  const { errors } = newS as any;
                  ToastModule.setToast({
                    message: `An error has occured: ${errors}`,
                    timeout: 5000,
                  });
                } catch {
                  //
                }
              }
              if (this.selectedUnitID) {
                try {
                  await this.onChangeUnit(this.selectedUnitID);
                } catch (err) {
                  ToastModule.setToast({
                    message: 'Error loading unit events',
                    timeout: 5000,
                  });
                }
              }
            }
          }, 5000);
          this.loadingIntervals.set(s.id as string, setIntervalNum);
        }
      });
      const start = formatISO(startOfMonth(new Date()), {
        representation: 'date',
      });
      const end = formatISO(endOfMonth(addMonths(new Date(), 6)), {
        representation: 'date',
      });

      const { data: events } = await marketApi.getEventsInMarket(
        marketId,
        start,
        end,
      );

      await this.getEventsInMarket();

      const generatedDates = new Set<string>();
      events.forEach((event) => {
        const ym = (event.date as string).substr(0, 7);
        generatedDates.add(ym);
      });
      this.marketGenerationStatus = generatedDates;
    } catch (err) {
      //
    }
  }

  public async getEventsInMarket() {
    const marketId = this.marketValue;
    const marketApi = new MarketsApi(AppModule.apiConfig);
    const startDate = moment().startOf('month').subtract(1, 'year').format('YYYY-MM-DD');
    const endDate = moment().endOf('month').add(6, 'month').format('YYYY-MM-DD');
    const fetchedEvents = await marketApi.getEventsInMarket(
      marketId,
      startDate,
      endDate,
    );
    this.eventsInMarketIDs = fetchedEvents.data;
  }

  public get canGenerateSchedule() {
    if (this.previousMonth) {
      return true;
    }
    if (this.$refs.calendar) {
      const currentcaldate = ((this.$refs.calendar as any).value);
      const date = currentcaldate.substr(0, 7);
      if (!this.marketGenerationStatus.has(date) || this.nonWorkingEvents) {
        return false;
      }
    }
    return true;
  }

  public async generateSchedule() {
    const marketId = this.marketValue;
    let { date } = this.start;
    if (!date) {
      date = this.spanValue || this.$route.query.date;
    }
    const marketApi = new MarketsApi(AppModule.apiConfig);
    this.saving = true;
    try {
      await marketApi.postGenerateScheduleInfo({
        date,
        marketId,
      });
    } catch (err) {
      ToastModule.setToast({
        message: 'An error has occured',
        timeout: 5000,
      });
    }
    try {
      await this.getMarketGenerationStatus();
    } catch (err) {
      ToastModule.setToast({
        message: 'Error reloading market information',
        timeout: 5000,
      });
    }
    if (this.selectedUnitID) {
      try {
        await this.onChangeUnit(this.selectedUnitID);
      } catch (err) {
        ToastModule.setToast({
          message: 'Error loading unit events',
          timeout: 5000,
        });
      }
    }
    this.saving = false;
  }

  public async getMarkets() {
    try {
      this.toggleEventID = '';
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { markets }: any = SystemModule;
          const items = MarketUtil.getMappedMarkets(markets);
          if (items) {
            const filterSortItems = orderBy(items, [(user:any) => user.text.toLowerCase()], 'asc');
            this.marketItems = filterSortItems;
          }
          const enabledIds = new Set<string>(
            FlagUtil.getFlags().market.scheduler_enabled,
          );
          this.marketItems = this.marketItems.filter((m) => enabledIds.has(m.value));
          if (!this.marketValue) {
            const { text, value } = (this.marketItems[0]) as any;
            this.marketValue = value;
            this.$router.replace({
              ...this.marketValue,
            }).catch(() => {});
          }
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  public onAccept(availableEvent: any) {
    this.onAavailabilityEvent(availableEvent, 'accepted', '');
  }

  public onDecline(availableEvent: any) {
    this.onAavailabilityEvent(availableEvent, 'declined', this.notesDecline);
  }

  public onCancel(availableEvent: any) {
    this.onAavailabilityEvent(availableEvent, 'canceled', this.notesDecline);
  }

  public onCancelAccept(availableEvent: any) {
    this.onAavailabilityEvent(availableEvent, 'canceled', '');
  }

  public onDeclineEventAdmin(availableEvent: any) {
    this.onAavailabilityEvent(availableEvent, 'declined', '');
  }

  public onAvailabilityEventDialog(status: string, availabilityEvent: any) {
    this.availabilityEventDialog = status;
    this.availabilityEvent = availabilityEvent || null;
    this.toggleEventID = '';
    this.notesDecline = '';
  }

  public async onAavailabilityEvent(availabilityEvent: any, status: string, notes: string) {
    try {
      this.availabilityEventLoading = true;
      const { id, name, unitName } = availabilityEvent;
      const eventDescription: any = {};
      if (notes) {
        const meta = {
          reason: notes,
          reasonDetails: notes,
        };
        eventDescription.meta = meta;
      }
      eventDescription.status = status;
      const api = new EventsApi(AppModule.apiConfig);
      const events: any = await api.patchEvent(id as string, eventDescription);
      if (events) {
        this.availabilityEventDialog = '';
        this.notesDecline = '';
        if (unitName) {
          ToastModule.setToast({
            message: `${unitName} has been notified of the update`,
            timeout: 5000,
          });
        }
        if (name) {
          ToastModule.setToast({
            message: `${name} has been notified of the update`,
            timeout: 5000,
          });
        }
        this.getAllEvents();
        if (this.adminUser) {
          this.onChangeUnit(this.selectedUnitID);
        }
        if (this.onBoardingPartnerID) {
          this.onChangePartner(this.partnerSelectID);
        }
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.availabilityEventLoading = false;
  }

  public getEventColor(event: any) {
    return event.color;
  }

  public updateRange(start: any, end: any) {
    this.start = start.start;
    this.end = start.end;
    if (this.isControl) {
      const { date } = start.start;
      this.$router.replace({
        query: {
          date,
        },
      }).catch(() => {});
    } else if (this.$route.query && this.$route.query.date) {
      const { date } = this.$route.query;
      if (date) {
        this.start = date;
        this.spanValue = date;
      }
    }
  }

  public async onPrev(): Promise<void> {
    this.isControl = true;
    this.spanValue = Format.getPrevMonth(this.spanValue);
  }

  public async onNext(): Promise<void> {
    this.isControl = true;
    this.spanValue = Format.getNextMonth(this.spanValue);
  }

  public async onChangeMarket(value: any) {
    this.disableMarkets = true;
    this.loadingMarkets = true;
    this.marketValue = value;
    this.$router
      .replace({
        name: 'scheduler-market',
        params: { marketId: value },
        query: { ...this.$route.query },
      })
      .catch(() => {});
    await this.getUnits();
    this.disableList = true;
    await this.getPartnersInMarket();
    await this.getMarketGenerationStatus();
    this.disableMarkets = false;
    this.disableList = false;
    this.loadingMarkets = false;
  }

  public async getUnits() {
    try {
      this.unitListLoading = true;
      this.toggleEventID = '';
      const api = new MarketsApi(AppModule.apiConfig);
      const fetchedUnits = await api.getUnitsInMarketId(this.marketValue);
      const updateData: any = UnitsUtil.activeUnits(fetchedUnits.data as any);
      this.unitUser = updateData;
      if (this.unitUser.length === 0) {
        this.unitListIcon = true;
        this.eventMeta = [];
      } else {
        this.unitListIcon = false;
      }

      const onBoardUnit = await UnitsUtil.getUnitUsers();
      this.assignedUnitUsers = onBoardUnit;
      if (this.onBoardingUnitUser && this.assignedUnitUsers.length === 1) {
        const unitUserId = this.unitUser[0].id;
        await this.onChangeUnitRole(unitUserId);
      } else if (this.accessAdminUser && this.unitUser.length > 0) {
        const unitUserId = this.unitUser[0].id;
        this.unitNameSelected = this.unitUser[0].unitName;
        await this.onChangeUnit(unitUserId);
      }
      this.unitListLoading = false;
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
  }

  public async getPartnersInMarket() {
    try {
      const api = new MarketsApi(AppModule.apiConfig);
      const fetchedPartners = await api.getPartnersInMarketId(this.marketValue);
      const updateData: any = ScheduleUtil.activePartners(fetchedPartners.data as any);
      const mappedPartnerMarket = MarketUtil.getMappedMarkets(updateData);
      this.partnerInMartkets = mappedPartnerMarket;
      const partnerUsers = await UnitsUtil.getPartnerList();
      this.partnersInMarkedID = updateData;
      this.assignedPartners = partnerUsers;
      if (this.assignedPartners.length === 1 && this.partnerInMartkets.length === 1) {
        const partnerID = this.partnerInMartkets[0].value;
        this.onChangePartner(partnerID);
      }
      if (this.onBoardingPartnerID && this.partnerInMartkets.length > 0) {
        const restaurantID = this.partnerInMartkets[0].value;
        this.onChangePartner(restaurantID);
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
  }

  public async onChangeUnit(value: any) {
    // filter the restaurant from schedule of units
    // const onBoardUnitRest = await UnitsUtil.getUnitRestaurants(value);
    // this.restaurantExcluded = onBoardUnitRest;

    // // filter the cuisines from schedule of units
    // const onBoardUnitCuisine = await UnitsUtil.getUnitRestaurantsCuisine(value);
    // this.cuisinesExcluded = onBoardUnitCuisine;
    try {
      this.disableList = true;
      this.selectedUnitID = value;
      const unitsApi = new UnitsApi(AppModule.apiConfig);
      const user: any = await unitsApi.getUnitById(value);
      const {
        schedule: { popupPattern, restaurantExclusions, cuisineExclusions },
      } = user.data;
      this.unitsPopupPattern = popupPattern;
      this.restaurantExcluded = restaurantExclusions;
      this.cuisinesExcluded = cuisineExclusions;
      const pop = ScheduleUtil.getUnitPopupPattern(popupPattern);
      if (pop.length > 0) {
        // eslint-disable-next-line
        this.greyOutUsers = pop[0];
      }
      if (pop.length === 0) {
        this.greyOutUsers = [];
      }
      this.saving = true;
      const startDate = moment().startOf('month').subtract(1, 'year').format('YYYY-MM-DD');
      const endDate = moment().endOf('month').add(6, 'month').format('YYYY-MM-DD');
      const nullDate: any = undefined;
      const api = new UnitsApi(AppModule.apiConfig);
      const events: any = await api.getUnitEvents(
        value, nullDate, startDate, endDate,
      );
      this.eventData = events.data;
      this.eventMeta = ScheduleUtil.getMappedEvents(events.data);
      const selectedArray = ScheduleUtil.getSelectedDates(this.eventMeta);
      this.eventSelectedDate = selectedArray;
      this.disableList = false;
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.saving = false;
  }

  public async onChangePartner(partnerID: any) {
    try {
      this.partnerSelectID = partnerID;
      this.saving = true;
      const unitsApi = new PartnersApi(AppModule.apiConfig);
      const user: any = await unitsApi.getPartnerById(partnerID);
      const { schedule: { popupPattern } } = user.data;
      if (popupPattern) {
        const pop = ScheduleUtil.getUnitPopupPattern(popupPattern);
        // eslint-disable-next-line
        this.greyOutUsers = pop[0]|| [];
      }
      const startDate = moment().startOf('month').subtract(1, 'year').format('YYYY-MM-DD');
      const endDate = moment().endOf('month').add(6, 'month').format('YYYY-MM-DD');
      const nullDate: any = undefined;
      const api = new PartnersApi(AppModule.apiConfig);
      const partnerUser = await api.getPartnerEvents(
        partnerID, nullDate, startDate, endDate,
      );
      if (this.onBoardingPartnerID) {
        this.eventMeta = await ScheduleUtil.getPartnerRoleEvents(partnerUser.data);
      }
    } catch (error) {
      console.log(error);
    }
    this.saving = false;
  }

  public async onChangeUnitRole(unitId: string) {
    try {
      this.selectedUnitID = unitId;
      this.saving = true;
      const unitsApi = new UnitsApi(AppModule.apiConfig);
      const user: any = await unitsApi.getUnitById(unitId);
      const { schedule: { popupPattern } } = user.data;
      const pop = ScheduleUtil.getUnitPopupPattern(popupPattern);
      // eslint-disable-next-line
      this.greyOutUsers = pop[0]|| [];
      const startDate = moment().startOf('month').subtract(1, 'year').format('YYYY-MM-DD');
      const endDate = moment().endOf('month').add(6, 'month').format('YYYY-MM-DD');
      const nullDate: any = undefined;
      const api = new UnitsApi(AppModule.apiConfig);
      const unitUser = await api.getUnitEvents(
        unitId, nullDate, startDate, endDate,
      );
      this.eventMeta = await ScheduleUtil.getMappedEvents(unitUser.data);
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.saving = false;
  }

  get onBoardingPartnerID() {
    if (UserModule.currentUser && UserModule.currentRole === 'partner_owner') {
      return UserModule.currentUser.id;
    }
    return '';
  }

  get onBoardingUnitUser() {
    if (UserModule.currentUser && UserModule.currentRole === 'unit_manager') {
      return UserModule.currentRole;
    }
    return null;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  get accessLimitUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    || UserModule.currentRole === 'partner_owner'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  get accessAdminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    || UserModule.currentRole === 'unit_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  get getPartnersItemsFiltered() {
    if (this.eventFetched.length > 0) {
      const filteredEvents = ScheduleUtil.getFilteredEventSearch(
        this.eventFetched, this.search,
      );
      return filteredEvents;
    }
    return '';
  }

  get getUnAvailablEventsFiltered() {
    if (this.fetchedUnAvailableEvents.length > 0) {
      const filteredEvents = ScheduleUtil.getFilteredEventSearch(
        this.fetchedUnAvailableEvents, this.search,
      );
      return filteredEvents;
    }
    return '';
  }

  get getCancelEventsFiltered() {
    if (this.fetchedCancelEvents.length > 0) {
      const filteredEvents = ScheduleUtil.getFilteredEventSearch(
        this.fetchedCancelEvents, this.search,
      );
      return filteredEvents;
    }
    return '';
  }

  get getNoResponseFiltered() {
    if (this.fetchedNoResponseEvents.length > 0) {
      const filteredEvents = ScheduleUtil.getFilteredEventSearch(
        this.fetchedNoResponseEvents,
        this.search,
      );
      return filteredEvents;
    }
    return '';
  }

  get getExcludedEventsFilter() {
    if (this.eventExclude.length > 0) {
      const filteredEvents = ScheduleUtil.getFilteredEventSearch(
        this.eventExclude,
        this.search,
      );
      return filteredEvents;
    }
    return '';
  }

  get getExcludedCuisineEventsFilter() {
    if (this.eventExcludeCuisine.length > 0) {
      const filteredEvents = ScheduleUtil.getFilteredEventSearch(
        this.eventExcludeCuisine,
        this.search,
      );
      return filteredEvents;
    }
    return '';
  }

  /*
 * add restautrant to the calendar
 */
  public async addEventToCalendar(item:any, selectedDate: any, index: any) {
    this.indexClicked = index;
    const eventMeta: any = {
      createdByUserId: this.userID,
      reason: item.name,
      description: item.name,
    };
    const eventType: any = 'standard';
    let eventStatus: any = '';
    if (this.cancelEvent.length > 0) {
      eventStatus = 'accepted';
    } else {
      eventStatus = 'draft';
    }
    const eventData: EventNew[] = [{
      unitId: this.selectedUnitID,
      date: selectedDate,
      type: eventType,
      status: eventStatus,
      meta: eventMeta,
      partnerId: item.id,
    }];
    try {
      this.eventSelectionLoader = true;
      const api = new EventsApi(AppModule.apiConfig);
      const events: any = await api.createEvent(eventData as any);
      const updatedEvents: any = events.data[0];
      const unitID = updatedEvents.unitId;
      if (events.data) {
        this.search = '';
        this.selectedDate = '';
        this.getAllEvents();
        this.onChangeUnit(unitID);
      }
      await this.getEventsInMarket();
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.eventSelectionLoader = false;
  }

  get userID() {
    return UserModule.userId;
  }

  public async getAllEvents() {
    try {
      const api = new EventsApi(AppModule.apiConfig);
      const events: any = await api.eventsGet();
      this.eventsAll = events.data;
    } catch (error) {
      //
    }
  }

  /*
   * Filtered the available and non available events
   */
  public async toggle(date: any) {
    this.toggleEventID = '';
    this.toggleLoading = true;
    const unitsApi = new UnitsApi(AppModule.apiConfig);
    const {
      availablePartners,
      unavailablePartners,
      cancelledPartners,
      noResponseEvents,
      excludedCuisines,
      excludedPartners,
    } = ((
        await unitsApi.getUnitTogglePartners(this.selectedUnitID, date))
      .data as UnitTogglePartners);
    this.eventFetched = availablePartners || [];
    this.fetchedUnAvailableEvents = ScheduleUtil
      .getUnavailableEventsFiltered((unavailablePartners as Array<PartnerWithKeys>));
    this.eventExclude = excludedPartners ? (excludedPartners as any) : [];
    this.eventExcludeCuisine = excludedCuisines ? (excludedCuisines as any) : [];
    this.fetchedCancelEvents = cancelledPartners || [];
    this.fetchedNoResponseEvents = noResponseEvents || [];
    this.toggleLoading = false;
    this.selectedDate = date;
  }

  /*
 * open the add restaurant menu
 */
  public toggleEvent(id: string) {
    if (id === this.toggleEventID) {
      this.toggleEventID = '';
    } else {
      this.toggleEventID = id;
    }
  }

  /*
 * delete the event of calendar
 */
  public async onDeleteEvent(eventID: string) {
    try {
      this.loading = true;
      const api = new EventsApi(AppModule.apiConfig);
      const events: any = await api.deleteEvent(eventID as string);
      if (events) {
        this.toggleEventID = '';
        this.getAllEvents();
        this.onChangeUnit(this.selectedUnitID);
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  /*
 * complete events and no show events
 */
  public async onChangeEventStatus(eventID: string, status: string, event: any) {
    try {
      this.loading = true;
      const { name, unitName } = event;
      const api = new EventsApi(AppModule.apiConfig);
      const eventDescription: any = {};
      eventDescription.status = status;
      const events: any = await api.patchEvent(eventID as string, eventDescription);
      if (events) {
        if (unitName) {
          ToastModule.setToast({
            message: `${unitName} has been notified of the update`,
            timeout: 5000,
          });
        }
        if (name) {
          ToastModule.setToast({
            message: `${name} has been notified of the update`,
            timeout: 5000,
          });
        }
        this.toggleEventID = '';
        this.getAllEvents();
        if (this.accessAdminUser) {
          this.onChangeUnit(this.selectedUnitID);
        }
        if (this.onBoardingPartnerID) {
          this.onChangePartner(this.partnerSelectID);
        }
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        this.selectedDate = '';
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  /* Get Unit Name for display in the cancel event modal */

  public getUnitName(unitName: string) {
    this.unitNameSelected = unitName;
  }

  /* publish to partners */

  public async onPublishPartners(item: string) {
    const monthDay = this.title;
    const publishDate = this.partnerPublishDate;
    const marketID = this.marketValue;
    if (item === 'partners' && this.partnerInMartkets) {
      try {
        this.publishPartnerLoader = true;
        this.disablePartners = true;
        const partners: any = await ScheduleUtil.getAsteriskEvents(
          this.partnerInMartkets, publishDate,
        );
        if (partners) {
          this.$router.push({
            name: 'publish-restaurants',
            params: {
              partners, monthDay, publishDate, marketID,
            },
          });
        }
      } catch (error) {
        //
      }
      this.publishPartnerLoader = false;
      this.disablePartners = false;
    }
    if (item === 'units' && this.unitUser) {
      try {
        this.publishPartnerLoader = true;
        this.disableUnits = true;
        const unitUpdateUser: any = await ScheduleUtil.getAestrickUnit(
          this.unitUser, publishDate,
        );
        const units = unitUpdateUser;
        if (units) {
          this.$router.push({
            name: 'publish-units',
            params: {
              units, monthDay, publishDate, marketID,
            },
          });
        }
      } catch (error) {
        // error handler
      }
      this.publishPartnerLoader = false;
      this.disableUnits = false;
    }
  }

  public onCloseAddRestaurant() {
    this.selectedDate = '';
    this.search = '';
  }

  public onMouseLeave() {
    this.search = '';
  }
}
